import { render, staticRenderFns } from "./ShippingMethodsRules.vue?vue&type=template&id=606aebf3&scoped=true"
import script from "./ShippingMethodsRules.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsRules.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethodsRules.vue?vue&type=style&index=0&id=606aebf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606aebf3",
  null
  
)

export default component.exports